import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Menu from "./components/Menu";
import WhyChooseUs from "./components/WhyChooseUs";
import Reviews from "./components/Reviews";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import StickyMobileCTA from "./components/StickyMobileCTA";
import OffersBanner from "./components/OffersBanner";
import OffersSection from "./components/OffersSection";
import CartDrawer from "./components/CartDrawer";
import CartFab from "./components/CartFab";
import { CartProvider } from "./context/CartContext";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AuthCallback from "./admin/AuthCallback";

const Home = () => (
  <CartProvider>
    <div className="min-h-screen bg-[#FAFAFA] text-black">
      <OffersBanner />
      <Navbar />
      <main>
        <Hero />
        <OffersSection />
        <Menu />
        <WhyChooseUs />
        <Reviews />
        <Gallery />
        <Contact />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
      <CartFab />
      <CartDrawer />
    </div>
  </CartProvider>
);

function AppRouter() {
  const location = useLocation();
  // Catch OAuth callback BEFORE rendering routes — the session_id arrives in URL hash
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
